<template>
  <split-button v-if="recentSearches || recentParcels">
    <template slot="primary">
      <button
        v-if="!searchBusy"
        class="button-label text-decoration-none border-0"
        type="submit"
        @click="updateCleared"
      >
        <SearchSVG :fillColor="'white'" />
        &nbsp;&nbsp;
        <span>SEARCH</span>
      </button>
    </template>
    <split-content>
      <a
        v-if="recentSearches"
        href="#"
        class="text-black text-nowrap text-decoration-none"
        data-bs-toggle="modal"
        data-bs-target="#recent-searches-modal"
      >
        <div class="dropdown-link">
          <SearchSVG :fillColor="'black'" />
          &nbsp;&nbsp;Recent Searches
        </div>
      </a>
      <a
        v-if="recentParcels"
        href="#"
        class="text-black text-nowrap text-decoration-none"
        data-bs-toggle="modal"
        data-bs-target="#recent-parcels-modal"
        @click="onSelectParcels"
      >
        <div class="dropdown-link">
          <SearchSVG :fillColor="'black'" />
          &nbsp;&nbsp;Recent Parcels
        </div>
      </a>
    </split-content>
  </split-button>
  <div v-else>
    <button
      v-if="!searchBusy"
      class="dropdown-button rounded flex-button button-label border-0"
      type="submit"
      @click="updateCleared"
    >
      <SearchSVG :fillColor="'white'" />
      &nbsp;&nbsp;
      <span>SEARCH</span>
    </button>
  </div>
</template>
<style></style>
<script>
import SplitButton from "../common/SplitButton.vue";
import SplitContent from "../common/SplitContent.vue";
import SearchSVG from "../svg/SearchSVG.vue";
export default {
  components: {
    SearchSVG,
    SplitButton,
    SplitContent,
  },
  methods: {
    async onSelectParcels() {
      if (!this.currentPayYear) {
        await this.getAndSetSystemParameters().then((res) => res);
      }
    },
  },
  props: {
    updateCleared: {
      type: Function,
      required: true,
    },
    searchBusy: {
      type: Boolean,
      required: true,
    },
    recentSearches: {
      type: Boolean,
      required: false,
    },
    recentParcels: {
      type: Boolean,
      required: false,
    },
    getAndSetSystemParameters: {
      type: Function,
      required: true,
    },
    currentPayYear: {
      type: String,
      required: false,
    },
  },
};
</script>
